import { NILS } from "./null-undefined";

/**
 * @returns True if input is not undefined or null. False otherwise.
 */
export function isDefined(input: any): input is Defined {
  return !NILS.includes(input);
}

export type Defined = {};
